import { all } from 'redux-saga/effects';

import { wsWatcher } from '@/app/sagas/websocket';
import { activityWatcher, feedWatcher } from '@/entities/activity';
import { balloonWatcher } from '@/entities/balloon';
import { gameMetaWatcher } from '@/entities/game';
import { jettonWatcher } from '@/entities/jetton';
import { leaderboardWatcher } from '@/entities/leaderboard';
import { minesWatcher } from '@/entities/mines';
import { referralWatcher } from '@/entities/referral';
import { rollsWatcher } from '@/entities/rolls';
import { userWatcher } from '@/entities/user';
import { withdrawWatcher } from '@/entities/withdraw';

export function* rootSaga() {
  yield all([
    wsWatcher(),
    userWatcher(),
    rollsWatcher(),
    jettonWatcher(),
    minesWatcher(),
    balloonWatcher(),
    leaderboardWatcher(),
    referralWatcher(),
    withdrawWatcher(),
    activityWatcher(),
    feedWatcher(),
    gameMetaWatcher(),
  ]);
}
